@if (!_expanded) {
  <div class="flex flex-col  justify-between md:justify-start ">
    <div class="flex flex-row items-center">
      @if (_rating && _rating.ratingcount > 0) {
        <div id="ratingvalue" class="text-2xl mr-2.5">{{_rating?.averageratingvalue | number:'1.1-1'}}</div>
      }
      @if (show_stars) {
        <ngb-rating [rate]="_rating?.averageratingvalue" [max]="5" [readonly]="true" aria-label="{{'customerrating.customerrating' |translate}}" >
          <ng-template let-fill="fill" let-index="index">
            <i class="bi-star{{ fill === 100 ? '-fill' : fill >= 50 ? '-half':'' }}"></i>
          </ng-template>
        </ngb-rating>
      }
    </div>
    @if (_rating && _rating.ratingcount > 0) {
      <small class="mr-5" id="ratingcount">{{'customerrating.average_of_x_ratings' | translate : {count:_rating?.ratingcount} }}</small>
    }
  </div>
}
@if (!_rating || _rating.ratingcount === 0) {
  <div class="mt-[5px]">
    <small id="noratings" class="flex items-center">
      <i class="bi bi-info-circle text-xl mr-2.5"></i><span class="ms-1"> {{'customerrating.no_ratings' | translate}}</span>
    </small>
  </div>
}
@if (_customerrating) {
  <div class="text-center md:text-left">
    <small><i>{{'customerrating.your_rating_score' | translate}}: {{_customerrating?.ratingvalue}}</i></small>
  </div>
}
@if (!createrating  && customer && !_customerrating) {
  <div class="" [@collapse]>
    <a class="cursor-pointer" (click)="createrating = true">
      <small>{{'customerrating.do_you_want_to_add_a_review'| translate}} <i class="bi bi-chevron-right"></i></small>
    </a>
  </div>
}
@if (createrating && customer) {
  <div class="" [formGroup]="ratingForm" [@collapse]>
    @if (!_expanded) {
      <a class="cursor-pointer" (click)="createrating = false">
        <small><i class="bi bi-chevron-left"></i> {{'common.cancel_button'| translate}} </small>
      </a>
    }
    @if (!isInOrderoveriew && !isNavigatedFromOrderoveriew) {
      <small id="isinorderoverview" class="flex items-center">
        <i class="bi bi-info-circle text-xl"></i><span class="ms-1">{{'customerrating.you_can_only_rate_in_orderoverview' | translate}}</span>
      </small>
    }
    @if ((isInOrderoveriew || isNavigatedFromOrderoveriew) && !isInOrder) {
      <small id="notinorder" class="flex items-center">
        <i class="bi bi-info-circle text-xl"></i><span class="ms-1">{{'customerrating.you_can_only_rate_if_entity_is_in_order' | translate}}</span>
      </small>
    }
    @if ((isInOrderoveriew || isNavigatedFromOrderoveriew) && isInOrder) {
      <div class="" id="ratingform">
        <label class="px-0">{{'customerrating.ratingvalue' | translate}}<span class="text-danger">*</span></label>
        <ngb-rating formControlName="ratingvalue" [max]="5">
          <ng-template let-fill="fill" let-index="index">
            <i class="bi-star{{ fill === 100 ? '-fill' : fill >= 50 ? '-half':'' }}" ></i>
          </ng-template>
        </ngb-rating>
      </div>
      <div class="form-field">
        <label>{{'customerrating.ratingremarks' | translate}}</label>
        <textarea class="mb-2.5" formControlName="ratingremarks" name="ratingremarks" placeholder="{{'customerrating.ratingremarks' | translate}}"></textarea>
      </div>
      <button class="button-mid rounded-md w-full py-2"
        (click)="addRating()"
        [disabled]="!ratingForm.valid">
        {{'customerrating.add_rating' | translate}}
      </button>
    }
  </div>
}
